import { apiClient } from '../api';
import type {
    AdminLegalDocumentCatalog,
    AdminLegalDocumentCatalogResponse,
    AdminProviderPayoutFeeSetting,
    AdminProviderPayoutFeeSettingResponse,
} from '../../types';
import type { SystemToolSettings, SystemToolSettingsResponse } from '../../types/systemTools';

export async function getProviderPayoutFeeSetting(): Promise<AdminProviderPayoutFeeSetting> {
    const response = await apiClient.get<AdminProviderPayoutFeeSettingResponse>(
        '/api/admin/platform-settings/provider-payout-fee'
    );

    return response.data;
}

export async function updateProviderPayoutFeeSetting(value: number): Promise<AdminProviderPayoutFeeSetting> {
    const response = await apiClient.put<AdminProviderPayoutFeeSettingResponse>(
        '/api/admin/platform-settings/provider-payout-fee',
        { value },
    );

    return response.data;
}

export async function getSystemToolSettings(): Promise<SystemToolSettings> {
    const response = await apiClient.get<SystemToolSettingsResponse>(
        '/api/admin/platform-settings/system-tools'
    );

    return response.data;
}

export async function updateSystemToolSettings(
    settings: SystemToolSettings,
): Promise<SystemToolSettings> {
    const response = await apiClient.put<SystemToolSettingsResponse>(
        '/api/admin/platform-settings/system-tools',
        settings,
    );

    return response.data;
}

export async function getLegalDocumentCatalog(): Promise<AdminLegalDocumentCatalog> {
    const response = await apiClient.get<AdminLegalDocumentCatalogResponse>(
        '/api/admin/platform-settings/legal-document-catalog'
    );

    return response.data;
}

export async function updateLegalDocumentCatalog(
    catalog: AdminLegalDocumentCatalog,
): Promise<AdminLegalDocumentCatalog> {
    const response = await apiClient.put<AdminLegalDocumentCatalogResponse>(
        '/api/admin/platform-settings/legal-document-catalog',
        catalog,
    );

    return response.data;
}
